import {APP_INITIALIZER, InjectionToken, Provider} from '@angular/core';
import {OrderRepository} from '@features/sales/domain/repositories/order.repository';
import {HttpOrderRepository} from '@features/sales/infrastructure/adapter/http-order.adapter';
import {SalesOnCartOpenedSubscriber} from "@features/sales/application/subscribers/sales-on-cart-opened.subscriber";
import {ORDER_STORE_STORAGE} from '../tokens/order-store-storage.token';
import {OrderState, OrderStore} from '@features/sales/application/store/order/order.store';
import {
  SalesOnServiceClosedSubscriber
} from '@features/sales/application/subscribers/sales-on-service-closed.subscriber';
import {WaiterSessionEndedEvent} from '@platform/event-bus/domain/events/waiter/waiter-session-ended.event';
import {CartPartitioner} from '@features/sales/domain/services/cart-partitioner.service';
import {SingleOrderSplitPolicy} from '@features/sales/domain/services/split-policies/single-order-split-policy.service';
import {RedemptionSplitPolicy} from '@features/sales/domain/services/split-policies/redemption-split-policy.service';
import {ByProductSplitPolicy} from '@features/sales/domain/services/split-policies/by-product-split-policy.service';
import {ByPercentageSplitPolicy} from '@features/sales/domain/services/split-policies/by-percentage-split-policy.service';
import {SALES_SESSION_PORT} from '@features/sales/domain/ports/sales-session.port';
import {SalesSessionAdapter} from '@features/sales/infrastructure/adapter/sales-session.adapter';
import {StoreIndexedDbStorage} from '@platform/storage/infrastructure/storage-indexdb.storage';
import {Logger} from 'src/app/core/interfaces/Logger';
import {StorageSynchronizer} from '@platform/storage/application/storage.synchronizer';
import {SalesOnPaymentStatusChangedSubscriber} from "@features/sales/application/subscribers/sales-on-payment-status-changed.subscriber";

export const DOMAIN_SUBSCRIBERS = new InjectionToken<unknown[]>('DOMAIN_SUBSCRIBERS');

export const SALES_PROVIDERS: Provider[] = [
  {
    provide: SALES_SESSION_PORT,
    useClass: SalesSessionAdapter,
  },
  {
    provide: OrderRepository,
    useClass: HttpOrderRepository,
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: SalesOnCartOpenedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: SalesOnServiceClosedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: WaiterSessionEndedEvent,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: SalesOnPaymentStatusChangedSubscriber,
    multi: true
  },
  {
    provide: ORDER_STORE_STORAGE,
    useFactory: (logger: Logger) => new StoreIndexedDbStorage<OrderState>(logger, 'sales'),
    deps: [Logger],
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (storage: StoreIndexedDbStorage<OrderState>, store: OrderStore) => new StorageSynchronizer<OrderState>(storage, store).sync(),
    deps: [ORDER_STORE_STORAGE, OrderStore],
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (subscribers: unknown[]) => () => void subscribers,
    deps: [DOMAIN_SUBSCRIBERS]
  },
  {
    provide: CartPartitioner,
    useFactory: () =>
      new CartPartitioner([
        new SingleOrderSplitPolicy(),
        new RedemptionSplitPolicy(),
        new ByProductSplitPolicy(),
        new ByPercentageSplitPolicy(),
      ]),
  },
];
